// src/swrConfig.js
import axios from "axios";
import Auth from "./Auth";
import posthog from "posthog-js";
import { ERROR_MESSAGES } from "./errorMessages";
import { captureWentOffline } from "./networkTelemetry";
import {
  isCancelledError,
  isOfflineError,
  isTimeoutError,
  isUnauthorizedError,
  isForbiddenError,
  isServerError,
  redirectToLogin,
} from "./requestErrorUtils";

export const cancelAllRequests = () => {
  // No-op: custom abort controller cancellation removed.
};

export const handleSWRError = (error, key, setGlobalError, dispatch) => {
  if (isCancelledError(error)) return;

  if (isUnauthorizedError(error)) {
    redirectToLogin(Auth.setToken);
    return;
  }

  if (isForbiddenError(error)) {
    setGlobalError({
      message: ERROR_MESSAGES.PERMISSION,
      showButtons: false,
      source: "swr",
      errorKey: key,
    });
    return;
  }

  if (isOfflineError(error)) {
    captureWentOffline({
      source: "swr",
      api_url: Array.isArray(key) ? key[0] : null,
      api_method: "GET",
      reason: "offline",
    });
    setGlobalError({
      message: ERROR_MESSAGES.OFFLINE_GET,
      persist: true,
      showButtons: true,
      source: "swr",
      errorKey: key,
    });
    return;
  }

  if (isTimeoutError(error)) {
    posthog?.capture("request_timeout", { url: window.location.pathname });
    setGlobalError({
      message: ERROR_MESSAGES.TIMEOUT,
      showButtons: true,
      showRetry: true,
      source: "swr",
      persist: false,
      errorKey: key,
    });
    dispatch({ type: "FETCH_ERROR" });

    return;
  }

  setGlobalError({
    message: isServerError(error)
      ? ERROR_MESSAGES.SERVER_GENERIC
      : ERROR_MESSAGES.LOAD_FAILED,
    showButtons: true,
    source: "swr",
  });
};

const fetcher = async (url, params) => {
  console.log("fetcher from swrConfig");
  if (!navigator.onLine) throw new Error("User offline");

  try {
    const res = await axios.get(url, {
      params,
      headers: Auth.getHeaders(),
    });

    return res.data;
  } catch (error) {
    throw error;
  }
};

const swrConfig = (setGlobalError, dispatch) => ({
  fetcher,
  onError: (error, key) => {
    handleSWRError(error, key, setGlobalError, dispatch);
  },
  onSuccess: (data, key) => {
    setGlobalError((prev) => (prev?.errorKey === key ? null : prev));
  },
  keepPreviousData: true,
  shouldRetryOnError: false,
  revalidateOnFocus: true,
  focusThrottleInterval: 30000,
  revalidateOnReconnect: true,
});

export default swrConfig;
